export var // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
RPCMethods;
(function(RPCMethods) {
    RPCMethods["CreateIdentity"] = 'create_identity';
    RPCMethods["SaveCredentials"] = 'save_credentials';
    RPCMethods["RemoveCredentials"] = 'remove_credentials';
    RPCMethods["CheckCredentialExistence"] = 'check_credential_existence';
    RPCMethods["CreateProof"] = 'create_proof';
    RPCMethods["CheckStateContractSync"] = 'check_state_contract_sync';
    RPCMethods["GetCredentials"] = 'get_credentials';
    RPCMethods["ExportIdentity"] = 'export_identity';
    RPCMethods["GetIdentity"] = 'get_identity';
})(RPCMethods || (RPCMethods = {}));
export var // Metamask user address for onchain proofs
// bigint string
OperationStatus;
(function(OperationStatus) {
    OperationStatus["Signed"] = 'SIGNED';
    OperationStatus["Initialized"] = 'INITIALIZED';
    OperationStatus["Approved"] = 'APPROVED';
    OperationStatus["NotApproved"] = 'NOT_APPROVED';
})(OperationStatus || (OperationStatus = {}));

//# sourceMappingURL=types.js.map